import { site } from '../config/site'
import { useReveal } from '../hooks/useReveal'
import { InteractiveGlobe } from './ui/InteractiveGlobe'

/**
 * Mounted between How-it-works and Why-Choose: the travel-globe artwork as an
 * interactive focal point, with a short centred statement above it. Pure
 * decoration — InteractiveGlobe handles the cursor-scrubbed rotation video,
 * this component only supplies layout, copy and the reveal-on-scroll
 * treatment shared by every other section.
 */
export function ExploreGlobe() {
  // Reveals once and stays (see HowItWorks.jsx for why `once: false` was
  // removed — it made content re-hide and cause visible blank/white gaps
  // during ordinary scrolling).
  const ref = useReveal()
  const { eyebrow, headline, highlight, body } = site.exploreGlobe

  return (
    <section ref={ref} className="overflow-hidden bg-[var(--surface)] pt-12 pb-16 sm:pt-16 sm:pb-24">
      <div className="mx-auto max-w-[88rem] px-5 sm:px-8">
        <header className="mx-auto max-w-2xl text-center">
          <p className="text-base font-bold text-brand-600 dark:text-brand-300" data-reveal>
            {eyebrow}
          </p>
          <h2
            className="mt-4 text-[clamp(2rem,4.4vw,3.4rem)] leading-[1.08] font-bold"
            data-reveal="rise"
            style={{ '--reveal-delay': '90ms' }}
          >
            {headline[0]}
            <br />
            <span className="text-brand-600 dark:text-brand-300">{highlight}</span>
          </h2>
          <p className="mt-5 text-[1.05rem] leading-relaxed" data-reveal style={{ '--reveal-delay': '160ms' }}>
            {body}
          </p>
        </header>

        <div className="mt-10 w-full sm:mt-14" data-reveal="pop" style={{ '--reveal-delay': '220ms' }}>
          <InteractiveGlobe />
        </div>
      </div>
    </section>
  )
}
